// Instâncias Axios dedicadas à API de Certidão Nada Consta.
//
// certidaoApi: emissão e download do PDF. Cada requisição recebe
// automaticamente o header Authorization: Bearer {token}, lido do
// localStorage, e desloga o usuário se o token expirar/for inválido. Sem
// x-api-key: a pessoa, o usuário e o CPF saem do próprio JWT, então cada um
// só emite/baixa a própria certidão.
//
// certidaoPublicaApi: validação da certidão (página aberta pelo QR Code). É
// pública — não manda token nem desloga em 401, pra não derrubar a sessão de
// quem por acaso estiver logado no mesmo navegador.

import axios from 'axios';

const baseURL = process.env.REACT_APP_CERTIDAO_API_URL;

const certidaoApi = axios.create({
  baseURL,
  timeout: 60000
});

certidaoApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

certidaoApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export const certidaoPublicaApi = axios.create({
  baseURL,
  timeout: 30000
});

export default certidaoApi;
